export interface PanelBadgeProps {
  props: { text: string; variant?: 'default' | 'success' | 'warning' | 'error' };
}

export function PanelBadge({ props }: PanelBadgeProps) {
  const { text, variant = 'default' } = props;

  const variantClass =
    variant === 'success'
      ? 'bg-sd-success/20 text-sd-success border-sd-success/30'
      : variant === 'warning'
        ? 'bg-sd-warning/20 text-sd-warning border-sd-warning/30'
        : variant === 'error'
          ? 'bg-sd-error/20 text-sd-error border-sd-error/30'
          : 'bg-sd-border/30 text-sd-text-secondary border-sd-border/50';

  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 text-sd-xs font-semibold rounded-sd-sm border ${variantClass}`}
    >
      {text}
    </span>
  );
}
